const projects = [
  {
    id: 'navigator-123',
    product: {
      technologies: ['es7', 'react', 'redux', 'webpack'],
      name: 'Navigator',
      year: 2018,
      city: 'Praha',
      hiringUrl: 'www.seznam.cz',
      description:
        'Get your customers onboarded with our technolgy. Get your customers onboarded with our technolgy.',
      productImage: 'https://i.imgur.com/ftyaPvt.png',
      links: {
        websiteUrl: 'www.mews.li/navigator',
        appStoreUrl: 'www.apple.cz',
      },
    },
    company: {
      name: 'Mews systems',
      companyImage: 'https://pbs.twimg.com/profile_images/756452276236083200/PcoFu5I2_400x400.jpg',
      companyUrl: 'https://www.mewssystems.com/',
    },
    social: {
      facebookUrl: 'https://www.facebook.com/MewsSystems/',
      linkedInUrl: 'https://www.linkedin.com/company/mews-systems/',
      twitterUrl: 'https://twitter.com/MewsSystems',
      instagramUrl: 'https://www.instagram.com/mewssystems/',
    },
    features: [
      {
        icon: 'teamIcon',
        title: 'Velikost týmu',
        description: '6 lidí',
      },
      {
        icon: 'teamIcon',
        title: 'Start projektu',
        description: '1.6.2018',
      },
      {
        icon: 'chartIcon',
        title: 'Návštevnost',
        description: '150 000 uživatelů mesíčně',
      },
      {
        icon: 'homeIcon',
        title: 'Lokace',
        description: 'Praha',
      },
    ],
    stories: [
      {
        profile: {
          profileImage:
            'https://ph-avatars.imgix.net/1005920/original?auto=format&auto=compress&codec=mozjpeg&cs=strip&w=140&h=140&fit=crop&dpr=2',
          twitterName: '@_linehan',
          name: 'Sean Linehan',
          position: 'VP of product ',
          company: 'Flexport',
        },
        lines: [
          'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Duis sapien nunc, commodo et, interdum suscipit, sollicitudin et, dolor.',
          'Suspendisse sagittis ultrices augue. Vestibulum erat nulla, ullamcorper nec, rutrum non, nonummy ac, erat.',
        ],
      },
      {
        profile: {
          name: 'Sean Linehan',
          profileImage:
            'https://ph-avatars.imgix.net/1005920/original?auto=format&auto=compress&codec=mozjpeg&cs=strip&w=140&h=140&fit=crop&dpr=2',
          twitterName: '@_linehan',
          position: 'VP of product ',
          company: 'Flexport',
        },
        lines: [
          'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Duis sapien nunc, commodo et, interdum suscipit, sollicitudin et, dolor.',
          'Suspendisse sagittis ultrices augue. Vestibulum erat nulla, ullamcorper nec, rutrum non, nonummy ac, erat.',
        ],
      },
    ],
    media: {
      images: [
        'https://breezy-gallery.imgix.net/45bb7/33c0b.jpg',
        'https://breezy-gallery.imgix.net/1adbe/66855.jpg',
        'https://breezy-gallery.imgix.net/45bb7/33c0b.jpg',
        'https://breezy-gallery.imgix.net/fab58/72f2c.jpg',
      ],
      videos: ['https://vimeo.com/273275435'],
    },
    contact: {
      email: 'support@mewssystems.com',
      address: {
        lines: ['Náměstí I. P. Pavlova 5.', '2. patro, Vinohrady', '120 00, Praha 2'],
      },

      cardTitle: 'Kontakt na nás.',
    },
  },
];

export default projects;
